import { themeVars } from '../theme/vars';
import { borderRadius, space } from '../tokens';
import { typography } from '../typography';
import { globalStyle, style, styleVariants } from '../layer.css';

const badgeBase = style([
  typography['labelMd'],
  {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: space.s8,
    cursor: 'default',
    padding: `${space.s6}px ${space.s12}px`,
    borderRadius: borderRadius.r32,
    whiteSpace: 'nowrap',
    width: 'fit-content',
    height: 'fit-content',
    transition: 'background-color 0.15s',
  },
]);

globalStyle(`.${badgeBase} :where(svg)`, {
  height: 16,
  width: 16,
  flexShrink: 0,
});

const badgeBgColor = {
  primary: themeVars.badge.primary.background,
  neutral: themeVars.badge.neutral.background,
  brand: themeVars.badge.brand.background,
  auxLightBlue: themeVars.badge.auxLightBlue.background,
  auxLightOrange: themeVars.badge.auxLightOrange.background,
  auxLightTeal: themeVars.badge.auxLightTeal.background,
  auxLightYellow: themeVars.badge.auxLightYellow.background,
} as const;

export const badge = styleVariants(badgeBgColor, (badge) => [
  badgeBase,
  {
    backgroundColor: badge.idle,
    color:
      badge === themeVars.badge.primary.background
        ? themeVars.badge.foreground.primary
        : themeVars.badge.foreground.default,

    selectors: {
      ['&[data-interactive]']: {
        cursor: 'pointer',
      },
      ['&[data-interactive]:hover']: {
        backgroundColor: badge.hover,
      },
      ['&[data-interactive]:active']: {
        backgroundColor: badge.active,
      },
    },
  },
]);

export const badgeStroke = style({
  boxShadow: `0 0 0 1px ${themeVars.badge.border.default}`,
});
